import PropTypes from 'prop-types';

import { HeadingLevel } from 'lib/customPropTypes';

const headingSizes = (level) => {
  const heading = `H${level}`;
  const levelStyles = {
    H1: 'text-3xl',
    H2: 'text-2xl',
    H3: 'text-xl',
    H4: 'text-lg',
    H5: 'text-base',
    H6: 'text-sm',
  };

  return levelStyles[heading];
};

const HX = ({ children, className, level, levelStyle = level, ...rest }) => {
  const DynamicHeading = `h${level}`;
  return (
    <DynamicHeading
      className={`${headingSizes(levelStyle)} ${className}`}
      {...rest}
    >
      {children}
    </DynamicHeading>
  );
};

HX.defaultProps = {
  className: '',
};

HX.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  level: HeadingLevel.isRequired,
  levelStyle: HeadingLevel.isRequired,
};

export default HX;
